var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasErrors)?_c('div',{staticClass:"alert alert-danger"},[_c('b-list-group',_vm._l((_vm.errors),function(error,idx){return _c('b-list-group-item',{key:idx},[_vm._v(_vm._s(error))])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }